import { Badge } from "@freightsimple/ui-core/Display/Badge";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";
import useInterval from "@/Hooks/useInterval";
import { useOnce } from "@/Hooks/useOnce";
import { useCoupons } from "@/Shared/Coupons/Hooks/useCoupons";

export function NavBarPotentialCoupon() {
  const { couponAmount, refreshCoupon } = useCoupons();

  // Refresh every 20 minutes
  useInterval(
    function () {
      refreshCoupon();
    },
    20 * 60 * 1000,
  );

  useOnce(async () => {
    refreshCoupon();
  });

  if (couponAmount === undefined) {
    return <></>;
  }

  return (
    <Tooltip
      side="right"
      content="You have a coupon that will automatically be applied to your next shipment. The prices you see listed include the coupon discount."
    >
      <Badge label={`Next Shipment: $${couponAmount} Off`} variant="warning" />
    </Tooltip>
  );
}
